// extracted by mini-css-extract-plugin
export default {"copy":"Fda-z","linkButton":"Gda-z"};